import { useState } from 'react';
import { avatarUrlFor } from '@gaintplay/core/names';

/** DiceBear face for a username. The same name always shows the same face. */
export function Avatar({
  name,
  size = 36,
  className = '',
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const box = `shrink-0 rounded-full border border-hairline bg-coin-tint ${className}`;
  // If DiceBear can't be reached, fall back to the first letter rather than a broken image.
  if (failed === name)
    return (
      <span
        aria-hidden="true"
        className={`grid place-items-center font-extrabold uppercase text-coin-ink ${box}`}
        style={{ width: size, height: size, fontSize: size * 0.42 }}
      >
        {name[0]}
      </span>
    );
  return (
    <img
      src={avatarUrlFor(name)}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(name)}
      className={box}
      style={{ width: size, height: size }}
    />
  );
}
